import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';
import {App} from './app';
import {tr} from './i18n/idioma';
import {evitarAbrirArchivosSoltados} from './utilidades/archivos-soltados';
// Letras del tema Sun Valley (incluidas en la app, sin depender de internet).
import '@fontsource/public-sans/400.css';
import '@fontsource/public-sans/500.css';
import '@fontsource/public-sans/600.css';
import '@fontsource/public-sans/700.css';
import '@fontsource/cinzel/600.css';
import './estilos.css';

const raiz = document.getElementById('raiz');
if (!raiz)
  throw new Error(
    tr('No se encontró el elemento raíz de la aplicación.', 'The root element of the application was not found.'),
  );

evitarAbrirArchivosSoltados();

createRoot(raiz).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
